// src/api/olt.api.js
import axios from "./axios";

/**
 * Obtener todas las OLTs registradas
 */
export const getOLTs = async () => {
  const res = await axios.get("/olts");
  return res.data;
};

/**
 * Crear una nueva OLT
 */
export const createOLT = async (data) => {
  const res = await axios.post("/olts", data);
  return res.data;
};

/**
 * Probar conectividad TELNET + SNMP contra una OLT
 */
export const testOLTConnection = async (oltId) => {
  const res = await axios.post(`/olts/${oltId}/test-connection`);
  return res.data;
};

/**
 * Disparar polling SNMP (Celery task)
 */
export const pollOLT = async (oltId) => {
  const res = await axios.post(`/olts/${oltId}/poll`);
  return res.data;
};

/**
 * Leer estado actual desde Redis (fallback DB)
 */
export const getOLTStatus = async (oltId) => {
  const res = await axios.get(`/olts/${oltId}/status`);
  return res.data;
};

/**
 * Eliminar una OLT por ID
 */
export const deleteOLT = async (oltId) => {
  const res = await axios.delete(`/olts/${oltId}`);
  return res.data;
};


/**
 * Actualizar una OLT existente
 */
export const updateOLT = async (oltId, data) => {
  const res = await axios.put(`/olts/${oltId}`, data);
  return res.data;
};


// ==========================================================
// NUEVAS FUNCIONES PARA OPERACIONES DE ONU
// ==========================================================

/**
 * Obtener ONUs no autorizadas de una OLT
 */
export const getUnauthorizedONUs = async (oltId) => {
  const res = await axios.get(`/olt/${oltId}/onus/unauthorized`);
  return res.data;
};

/**
 * Obtener tipos de ONU disponibles
 */
export const getONUTypes = async (oltId) => {
  const res = await axios.get(`/olt/${oltId}/onu-types`);
  return res.data;
};

/**
 * Crear un nuevo tipo de ONU
 */
export const createONUType = async (oltId, data) => {
  const res = await axios.post(`/olt/${oltId}/onu-types`, data);
  return res.data;
};

/**
 * Eliminar un tipo de ONU
 */
export const deleteONUType = async (oltId, typeId) => {
  const res = await axios.delete(`/olt/${oltId}/onu-types/${typeId}`);
  return res.data;
};

/**
 * Obtener perfiles de tráfico
 */
export const getTrafficProfiles = async (oltId) => {
  const res = await axios.get(`/olt/${oltId}/traffic-profiles`);
  return res.data;
};

/**
 * Crear un perfil de tráfico
 */
export const createTrafficProfile = async (oltId, data) => {
  const res = await axios.post(`/olt/${oltId}/traffic-profiles`, data);
  return res.data;
};


/**
 * Eliminar un perfil de tráfico
 */
export const deleteTrafficProfile = async (oltId, profileId) => {
  const res = await axios.delete(`/olt/${oltId}/traffic-profiles/${profileId}`);
  return res.data;
};
/**
 * Autorizar una ONU
 */
export const authorizeONU = async (data) => {
  const res = await axios.post('/olt/authorize-onu', data);
  return res.data;
};

/**
 * Consultar estado de autorización de ONU
 */
export const getAuthorizeStatus = async (taskId) => {
  const res = await axios.get(`/olt/authorize-onu/status/${taskId}`);
  return res.data;
};

/**
 * Eliminar una ONU por su índice
 * @param {number} oltId - ID de la OLT
 * @param {string} onuIndex - Índice de la ONU (ej: "1-1-2-14")
 */
export const deleteONU = async (oltId, onuIndex) => {
  const res = await axios.delete(`/olt/${oltId}/onus/${onuIndex}`);  // ← "olt" singular
  return res.data;
};
